module.exports = __webpack_public_path__ + "img/ipad-cn-2.730fd37.jpg";